import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { filter, Subscription, take } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { AuthService } from 'src/app/services/auth.service';
import Swal from 'sweetalert2';
import { SetUserAction } from 'src/app/redux/user.actions';

@Component({
    selector: 'app-edit-profile',
    templateUrl: './edit-profile.component.html',
    styleUrls: ['./edit-profile.component.scss'],
    standalone: false
})
export class EditProfileComponent implements OnInit, OnDestroy {

  userSubscription: Subscription = new Subscription();
  formSubscription: Subscription = new Subscription();

  public registerFG: FormGroup;
  hide = true;
  profileImageSrc = "../../../assets/img/icon_red.png";
  profileImageBase64 = "";
  imgExt = "";
  userCv: any;
  espec = [];
  userId = 0;
  tmzselected = 'America/Mexico_City'
  countrySelected = 'MX'
  hasProfileChanges = false;
  private profileLoaded = false;
  private photoChanged = false;
  private loadingProfile = false;
  private loadedProfileUserId = 0;

  timeZones = [];

  constructor(private _formBuilder: FormBuilder, private store: Store<AppState>, private service: AuthService) { }

  ngOnInit() {
    const detectedTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Mexico_City';
    this.timeZones = this.getLocalTimeZones(detectedTimeZone);

    this.registerFG = this._formBuilder.group({
      first_name: [{ value: "", disabled: true }],
      last_name: [{ value: "", disabled: true }],
      email: [{ value: "", disabled: true },],
      country_code: ['+52', Validators.required],
      phone_number: [{ value: "", disabled: true }],
      country: ["MX", Validators.required],
      date_of_birth: ["", Validators.required],
      gender: ["", Validators.required],
      time_zone: ["America/Mexico_City", Validators.required],
    });

    this.userSubscription = this.store.select('user').pipe(
      filter((data: any) => !!data?.data?.id),
      take(1)
    ).subscribe(data => {
      let user = data.data;

      this.userId = user.id;
      if (this.loadingProfile || (this.profileLoaded && this.loadedProfileUserId === user.id)) {
        return;
      }

      this.loadingProfile = true;

      this.service.getProfile(user.id).subscribe((d: any) => {
        let decUser = this.service.parseEncryptedResponse(d,"private");

        let profile = decUser.data.items[0];
        console.log(profile);

        this.profileImageSrc = this.getProfileImageUrl(profile);
        this.profileImageBase64 = "";
        this.syncUserProfile(profile);

        const profileTimeZone = profile.time_zone || detectedTimeZone || 'America/Mexico_City';
        if (!this.timeZones.includes(profileTimeZone)) {
          this.timeZones = [profileTimeZone, ...this.timeZones];
        }
        this.tmzselected = profileTimeZone;

        this.registerFG.setValue({
          first_name: profile.first_name,
          last_name: profile.last_name,
          email: profile.email,
          country_code: '+52',
          phone_number: profile.phone,
          country: profile.country || 'MX',
          date_of_birth: this.formatBirthDateInput(profile.birth_at),
          gender: this.normalizeGender(profile.gender),
          time_zone: profileTimeZone,
        }, { emitEvent: false });

        this.profileLoaded = true;
        this.loadedProfileUserId = user.id;
        this.photoChanged = false;
        this.hasProfileChanges = false;
        this.registerFG.markAsPristine();
        this.formSubscription.unsubscribe();
        this.formSubscription = this.registerFG.valueChanges.subscribe(() => {
          if (!this.profileLoaded) return;
          this.hasProfileChanges = this.registerFG.dirty || this.photoChanged;
        });

        console.log('FORMULARIO',this.registerFG.value)
        this.loadingProfile = false;
      }, err => {
        this.loadingProfile = false;
        this.service.handleRequestError(err, {
          fallback: 'No pudimos cargar tu perfil. Intenta de nuevo en unos minutos.'
        });
      })
    })
  }

  ngOnDestroy() {
    this.userSubscription.unsubscribe();
    this.formSubscription.unsubscribe();
  }

  register() {

    // let userData = new FormData();
    let date = this.registerFG.value.date_of_birth_convert;
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();

    let user = {
      "role_id": (this.registerFG.value.role_id),
      "first_name": (this.registerFG.value.first_name),
      "last_name": (this.registerFG.value.last_name),
      "email": (this.registerFG.value.email),
      "password": (this.registerFG.value.password),
      "country_code": (this.registerFG.value.country_code),
      "phone_number": (this.registerFG.value.phone_number),
      "country": (this.registerFG.value.country),
      "date_of_birth": (`${day}-${month}-${year}`),
      "gender": (this.registerFG.value.gender),
      "time_zone": (this.registerFG.value.time_zone)
    }
    console.log(user)
  }

  clickFile(id) {
    document.getElementById(id).click();
  }

  getFile(event) {
    let file = event.target.files[0];
    if (!file) return;
    this.imgExt = file.name.split(".")[1];
    let reader = new FileReader();
    reader.onload = this.fileOnload.bind(this);
    reader.readAsDataURL(file);
  }

  fileOnload(e) {
    const result = e.target.result || "";
    this.profileImageSrc = result;
    this.profileImageBase64 = String(result).split(",")[1] || "";
    this.photoChanged = true;
    this.hasProfileChanges = true;
  }

  saveForm() {
    const birthAt = this.parseBirthDate(this.registerFG.value.date_of_birth);

    let user = {
      "country_code": (this.registerFG.value.country_code),
      "country": (this.registerFG.value.country),
      "gender": (this.registerFG.value.gender),
      "time_zone": this.registerFG.value.time_zone,
      "birth_at": birthAt,
      "base64": this.photoChanged ? this.profileImageBase64 : "",
      base64_extension: this.imgExt
    }

    if(!this.hasProfileChanges){
      return;
    }

    if(!this.registerFG.valid){
      Swal.fire({
        icon: 'error',
        title: 'Campos inválidos',
        text: "Alguno de los campos no es válido, favor de revisar.",
        showConfirmButton: true,
            confirmButtonText: "ok",
            confirmButtonColor:'#023171',
      });
      return
    }

    console.log(user)

    this.service.editProfile(user, this.userId).subscribe(data => {
      const decData = this.service.parseEncryptedResponse(data, 'private');
      const updatedProfile = decData?.data?.items?.[0] || decData?.data || decData || {};
      const updatedImageUrl = this.getProfileImageUrl(updatedProfile);

      if (updatedImageUrl) {
        this.profileImageSrc = updatedImageUrl;
      }

      this.service.user = {
        ...this.service.user,
        ...updatedProfile,
        photo_media_id: updatedProfile.photo_media_id || this.service.user?.photo_media_id
      };
      this.syncUserProfile(this.service.user);

      this.photoChanged = false;
      this.profileImageBase64 = "";
      this.hasProfileChanges = false;
      this.registerFG.markAsPristine();
      Swal.fire({
        icon: 'success',
        title: 'Listo',
        text: "Perfil modificado",
        showConfirmButton: true,
            confirmButtonText: "ok",
            confirmButtonColor:'#023171',
      });
    }, err => {
      this.service.handleRequestError(err, {
        fallback: 'No pudimos guardar tu perfil. Intenta de nuevo en unos minutos.'
      });
    })
  }

  private getLocalTimeZones(detectedTimeZone: string): string[] {
    const intlWithSupportedValues = Intl as any;
    const browserTimeZones = typeof intlWithSupportedValues.supportedValuesOf === 'function'
      ? intlWithSupportedValues.supportedValuesOf('timeZone')
      : [];

    return [...new Set([
      detectedTimeZone,
      'America/Mexico_City',
      'America/Cancun',
      'America/Monterrey',
      'America/Tijuana',
      ...browserTimeZones,
    ].filter(Boolean))];
  }

  private formatBirthDateInput(value: any): string {
    if (!value) return "";

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  private parseBirthDate(value: string): number | null {
    if (!value) return null;

    const date = new Date(`${value}T00:00:00`);
    return Number.isNaN(date.getTime()) ? null : date.getTime();
  }

  private normalizeGender(value: string): string {
    const gender = String(value || '').toLowerCase();
    if (gender === 'male' || gender === 'masculino') return 'male';
    if (gender === 'female' || gender === 'femenino') return 'female';
    return '';
  }

  private syncUserProfile(profile) {
    if (!profile) return;

    this.service.user = {
      ...this.service.user,
      ...profile,
      photo_media_id: profile.photo_media_id || this.service.user?.photo_media_id
    };

    this.store.dispatch(new SetUserAction({ ...this.service.user }));
    localStorage.setItem('mindhelp_user', JSON.stringify(this.service.user));
  }

  private getProfileImageUrl(profile): string {
    const candidates = [
      profile && profile.photo_media_id,
      profile && profile.profile_image_url,
      profile && profile.profile_image,
      profile && profile.photo_url,
      profile && profile.avatar_url,
      profile && profile.image_url,
      profile && profile.media,
      profile && profile.photo,
      profile && profile.avatar,
    ];

    for (const candidate of candidates) {
      const imageUrl = this.extractImageUrl(candidate);
      if (imageUrl) return imageUrl;
    }

    return "../../../assets/img/icon_red.png";
  }

  private extractImageUrl(value): string {
    if (!value) return "";

    if (typeof value === "string") {
      return this.normalizeImageUrl(value);
    }

    if (typeof value !== "object") {
      return "";
    }

    const imageKeys = [
      "url",
      "secure_url",
      "public_url",
      "media_url",
      "file_url",
      "full_url",
      "location",
      "path",
      "src",
    ];

    for (const key of imageKeys) {
      const imageUrl = this.extractImageUrl(value[key]);
      if (imageUrl) return imageUrl;
    }

    return "";
  }

  private normalizeImageUrl(value: string): string {
    const imageUrl = value.trim();
    if (!imageUrl) return "";

    if (
      imageUrl.startsWith("data:image") ||
      imageUrl.startsWith("http://") ||
      imageUrl.startsWith("https://") ||
      imageUrl.startsWith("./") ||
      imageUrl.startsWith("/")
    ) {
      return imageUrl;
    }

    if (imageUrl.startsWith("assets/")) {
      return `./${imageUrl}`;
    }

    return "";
  }
}
